import { BATCH_CLOSED_REASONS, BATCH_STATUSES, BATCH_TYPES, SUBSCRIPTION_PLAN_CATEGORY } from './Enums';

export type IAddAdmins = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  userType: string | null;
};

export type IStartEndBody = {
  startDate?: string;
  endDate?: string;
};

export type IGetAdmins = {
  page: number | string;
  limit: number;
  search: string;
};

export type IAddAdminsResponse = {
  success: boolean;
  token: string;
  message: string;
};

export type IGetAdminsDocs = {
  createdAt: string;
  fcm: string[];
  firstName: string;
  lastName: string;
  updatedAt: string;
  userType: string;
  username: string;
  _id: string;
};
export type IGetAdminsResponse = IPaginationType & {
  docs: IGetAdminsDocs[];
};

export type IGetSubscriptionPlansResponse = IPaginationType & {
  docs: IGetSubscriptionPlans[];
};
export type IGetSubscriptionPlans = {
  _id: string;
  active: boolean;
  createdAt: string;
  deliveries: number;
  description: string;
  planName: string;
  planType: string;
  price: number;
  colorCode: string;
  updatedAt: string;
  category: SUBSCRIPTION_PLAN_CATEGORY;
  durationDays: number;
};

export type ILoginResponse = {
  accessToken: string;
  refreshToken: string;
  isEmailVerified: boolean;
};

export type ApiResponse<T> =
  | { success: true; data: T }
  | { success: false; error: any; statusCode: number };

export type IGetDashboardStats = {
  users: number;
  drivers: number;
};

type IGetAllUsersDataDocs = {
  completedOrders: number;
  createdAt: string;
  email: string;
  fullName: string;
  gender: string;
  isBlocked: boolean;
  isEmailVerified: boolean;
  phone: string;
  points: 0;
  profileImage: string;
  referredBy: {
    _id: string;
    email: string;
  };
  state: string;
  totalOrders: number;
  updatedAt: string;
  username: string;
  _id: string;
};

export type IGetAllUsers = IPaginationType & {
  docs: IGetAllUsersDataDocs[];
};

export type IGetAllOffersResponse =
  | {
    totalDocs?: number;
    limit?: number;
    page?: number;
    totalPages?: number;
    pagingCounter?: number;
    hasPrevPage?: boolean;
    hasNextPage?: boolean;
    prevPage?: any;
    nextPage?: any;
    docs: {
      _id: string;
      credits: number;
      isOfferActive: boolean;
      createdAt: string;
      updatedAt: string;
    }[];
  }
  | any;

export type IStates = {
  states: [
    { label: 'Alabama'; value: 'AL' },
    { label: 'Alaska'; value: 'AK' },
    { label: 'Arizona'; value: 'AZ' },
    { label: 'Arkansas'; value: 'AR' },
    { label: 'California'; value: 'CA' },
    { label: 'Colorado'; value: 'CO' },
    { label: 'Connecticut'; value: 'CT' },
    { label: 'Delaware'; value: 'DE' },
    { label: 'Florida'; value: 'FL' },
    { label: 'Georgia'; value: 'GA' },
    { label: 'Hawaii'; value: 'HI' },
    { label: 'Idaho'; value: 'ID' },
    { label: 'Illinois'; value: 'IL' },
    { label: 'Indiana'; value: 'IN' },
    { label: 'Iowa'; value: 'IA' },
    { label: 'Kansas'; value: 'KS' },
    { label: 'Kentucky'; value: 'KY' },
    { label: 'Louisiana'; value: 'LA' },
    { label: 'Maine'; value: 'ME' },
    { label: 'Maryland'; value: 'MD' },
    { label: 'Massachusetts'; value: 'MA' },
    { label: 'Michigan'; value: 'MI' },
    { label: 'Minnesota'; value: 'MN' },
    { label: 'Mississippi'; value: 'MS' },
    { label: 'Missouri'; value: 'MO' },
    { label: 'Montana'; value: 'MT' },
    { label: 'Nebraska'; value: 'NE' },
    { label: 'Nevada'; value: 'NV' },
    { label: 'New Hampshire'; value: 'NH' },
    { label: 'New Jersey'; value: 'NJ' },
    { label: 'New Mexico'; value: 'NM' },
    { label: 'New York'; value: 'NY' },
    { label: 'North Carolina'; value: 'NC' },
    { label: 'North Dakota'; value: 'ND' },
    { label: 'Ohio'; value: 'OH' },
    { label: 'Oklahoma'; value: 'OK' },
    { label: 'Oregon'; value: 'OR' },
    { label: 'Pennsylvania'; value: 'PA' },
    { label: 'Rhode Island'; value: 'RI' },
    { label: 'South Carolina'; value: 'SC' },
    { label: 'South Dakota'; value: 'SD' },
    { label: 'Tennessee'; value: 'TN' },
    { label: 'Texas'; value: 'TX' },
    { label: 'Utah'; value: 'UT' },
    { label: 'Vermont'; value: 'VT' },
    { label: 'Virginia'; value: 'VA' },
    { label: 'Washington'; value: 'WA' },
    { label: 'Washington, D.C'; value: 'DC' },
    { label: 'West Virginia'; value: 'WV' },
    { label: 'Wisconsin'; value: 'WI' },
    { label: 'Wyoming'; value: 'WY' },
  ];
};

export type IUserDetails = {
  completedOrders: number;
  totalOrders: number;
  data: {
    appversion: string;
    createdAt: string;
    createdBy: string;
    customerId: string;
    email: string;
    fcm: string[];
    fullName: string;
    gender: string;
    isBiometricEnabled: boolean;
    isBlocked: boolean;
    isEmailVerified: boolean;
    lastOpenAt: string;
    mainProductsOfDelivery: any[];
    phone: string;
    profileImage: string;
    publicKey: string | null;
    rating: number;
    ratingCount: number;
    referredBy: any | null;
    selectedAccountType: string;
    state: string;
    status: string;
    updatedAt: string;
    username: string;
    __v: number;
    _id: string;
  };
};

export type IBussinessAccountDocs = {
  businessAddress: {
    address: string;
    city: string;
    country: string;
    lat: number;
    lng: number;
    locationName: string;
    state: string;
  };
  _id: string;
  fullName: string;
  email: string;
  username: string;
  phone: string;
  gender: string;
  profileImage: string;
  state: string;
  isBlocked: boolean;
  isEmailVerified: boolean;
  createdAt: string;
  updatedAt: string;
  completedOrders: number;
  totalOrders: number;
  points: number;
  selectedAccountType: string;
  businessName: string;
  businessWebsite: string;
  mainProductsOfDelivery: string[];
  referredBy: {
    _id: string | null;
    email: string | null;
  } | null;
};
export type IGetBussinessAccounts = IPaginationType & {
  docs: IBussinessAccountDocs[];
};

export type IGetAllDrivers = IPaginationType & {
  docs: IDocsDriver[];
};
export type IDocsDriver = {
  createdAt: string;
  drivingLicenseFile: string;
  email: string;
  fullName: string;
  gender: string;
  isBlocked: boolean;
  isEmailVerified: boolean;
  isProfileCompleted: boolean;
  isStripeConnected: boolean;
  phone: string;
  profileImage: string;
  rating: number;
  updatedAt: string;
  vehicleInsuranceFile: string;
  vehicleNumber: string;
  vehicleRegistrationFile: string;
  vehicleType: string;
  verificationStatus: string;
  wallet: number;
  _id: string;
  totalOrders: number;
  completedOrders: number;
  candidate_id?: string;
  state: string;
  completedCount: number;
  cancelledCount: number;
};

export type IWhoAmI = {
  _id: string;
  firstName: string;
  lastName: string;
  userType: string;
  username: string;
  fcm: string[];
  passwordChangedAt: string;
};

export type IGetAllServices = IPaginationType & {
  docs: IGetAllServicesDocs[];
};

export type IGetAllServicesDocs = {
  _id: string;
  driver: IDocsDriver[];
  user: IUserType[];
  serviceMeta: string;
  serviceMetaType: string;
  status: string;
  driverTotal: number;
  createdAt: string;
  updatedAt: string;
  userTotal: number;
  ratingByUser: {
    feedback: string;
    rating: number;
  };
  curbside_pickup_meta: [];
  package_pickup_meta: [];
  instore_pickup_meta: [];
};

export type IGetAllServiceBody = {
  type?: string;
  page?: number;
  createdago?: string;
  fromdate?: string;
  todate?: string;
  users?: string;
  drivers?: string;
  limit: number;
  status: string;
};

export type IUserType = {
  email: string;
  fullName: string;
  gender: string;
  phone: string;
  profileImage: string;
  _id: string;
};

export type IGetAllFeedbackDataDocs = {
  build: string;
  createdAt: string;
  device: string;
  driver: [] | any;
  experienceRating: 4;
  feedback: string;
  status: string;
  updatedAt: string;
  user: [] | any;
  userType: string;
  _id: string;
};
export type IGetAllFeedback = IPaginationType & {
  docs: IGetAllFeedbackDataDocs[];
};

export type submissionRequestDriver = {
  createdAt: string;
  driver: {
    email: string;
    fullName: string;
    gender: string;
    phone: string;
    profileImage: string;
    vehicleNumber: string;
    vehicleType: string;
    _id: string;
  };
  isAllowedToResubmit: boolean;
  status: SUBMISSION_REQUEST_STATUSES;
  reason: string;
  updatedAt: string;
  _id: string;
};

export enum SUBMISSION_REQUEST_STATUSES {
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export type IGetAllSubmissionRequest = IPaginationType & {
  docs: submissionRequestDriver[];
};

export type IUnreadCounts = {
  count: number;
};

export type IPromoCodeType = {
  createdAt: string;
  currentUsage: number;
  description: string;
  discountType: string;
  discountValue: number;
  expiryDate: null | string;
  maxUsers?: number;
  maxBudget?: number;
  promoCode: string;
  remainingBudget: null | number;
  serviceType: [
    'package_pickup_meta' | 'curbside_pickup_meta' | 'instore_pickup_meta',
  ];
  startDate: string;
  isNotifyUser?: boolean;
  isPromoCodeActive?: boolean;
  isSingleUse: boolean;
  _id: string;
};

export type IGetAllPromoCode = IPaginationType & {
  docs: IPromoCodeType[];
};

export type IGetAllOffers = IPaginationType & {
  docs: docsOffers[];
};

export type docsOffers = {
  _id: string;
  credits: string;
  discountValue?: number;
  discountType?: string;
  startDate: string;
  expiryDate?: string;
  userType?: string;
  serviceType?: [
    'package_pickup_meta' | 'curbside_pickup_meta' | 'instore_pickup_meta',
  ];
  pointsRequired: number;
  isOfferActive?: boolean;
};

export type ServiceType = {
  _id: string;
  driver: IDocsDriver[];
  user: IUserType[];
  serviceMeta: string;
  serviceMetaType: string;
  status: string;
  driverTotal: number;
  createdAt: string;
  updatedAt: string;
  userTotal: number;
  ratingByUser: {
    feedback: string;
    rating: number;
  };
  curbside_pickup_meta: [];
  package_pickup_meta: [];
  instore_pickup_meta: [];
};

export type IPaginationType = {
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextPage: number | null;
  prevPage: number | null;
  pagingCounter: number;
};

export type IDriverDetails = IDocsDriver & {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  vehicleNumber: string;
  vehicleType: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleMakeYear: string;
  profileImage: string;
  drivingLicenseFile: string;
  vehicleInsuranceFile: string;
  gender: string;
  fcm: string[];
  isOnline: boolean;
  isBlocked: boolean;
  isEmailVerified: boolean;
  verificationStatus: string;
  isProfileCompleted: boolean;
  isStripeConnected: boolean;
  publicKey: string | null;
  isBiometricEnabled: boolean;
  createdBy: string;
  ratingCount: number;
  rating: number;
  ongoingOrder: string | null;
  appversion: number;
  wallet: number;
  pendingForClearance: string;
  isEligibleForPayout: boolean;
  status: string;
  driverLicenseNumber: string;
  driverLicenseState: string;
  dob: string;
  state: string;
  lastOpenAt: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  totalEarning: number;
  totalOrders: number;
  completedOrders: number;
  coords: {
    type: string;
    coordinates: [number, number];
  };
};

export type IDriverAnalysis = {
  cancellationRate: number | string;
  completedRate: number | string;
  notifiedCount: number;
};

export type IStatsResponse = {
  brands: number | null;
  drivers: number | null;
  users: number | null;
  activeOrders: number | null;
  cancelledOrders: number | null;
  completedOrders: number | null;
  newDrivers: number | null;
  ordersCount: number | null;
  newUsers: number | null;
  totalBatches: number | null;
  pendingBatches: number | null;
  activeBatches: number | null;
  completedBatches: number | null;
};

export type IFirstOpenResponse = {
  metrics: string[];
  dimensions: string[];
};

export type IAppVersionBody = {
  latestVersion: string;
  isUpdateRequired: boolean;
  userType: string;
  platform?: string;
};

export type IAppVersionResponse = {
  latestVersion: string;
  buildNumber: number;
  isUpdateRequired: boolean;
  userType: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type IChangePasswordResponse = {
  success: boolean;
  message: string;
};

export type IVerifyOtpBody = {
  code: number;
  email: string;
};

export type IBussinessAccountDetailResponse = {
  data: IBussinessAccountDocs;
  totalOrders: number;
  completedOrders: number;
};

export type IBussinessAccountBody = {
  page?: number | string;
  search?: string;
  fromDate?: string;
  todate?: string;
  state?: string;
};

export type ICreateDriversBody = {
  fullName: string;
  email: string;
  password: string;
  phone: string;
  vehicleNumber: string;
  profileImage: string;
  drivingLicenseFile: string;
  zipCode: string;
  vehicleType: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleMakeYear: string;
  dob: string;
  driverLicenseNumber: string;
  driverLicenseState: string;
  state: string;
  vehicleInsuranceFile: string;
};

export type ICreateDriverResponse = {
  fullName: string;
  email: string;
  password: string;
  phone: string;
  zipCode: number;
  coords: {
    type: string;
    coordinates: [number, number];
  };
  vehicleNumber: string;
  vehicleType: string;
  vehicleMake: string;
  vehicleModel: string;
  vehicleMakeYear: string;
  profileImage: string;
  drivingLicenseFile: string;
  vehicleInsuranceFile: string;
  gender: string;
  fcm: string[];
  isOnline: boolean;
  isBlocked: boolean;
  isEmailVerified: boolean;
  verificationStatus: string;
  isProfileCompleted: boolean;
  isStripeConnected: boolean;
  publicKey: string | null;
  isBiometricEnabled: boolean;
  createdBy: string;
  ratingCount: number;
  rating: number;
  ongoingOrder: string | null;
  appversion: number;
  wallet: number;
  pendingForClearance: number;
  isEligibleForPayout: boolean;
  status: string;
  driverLicenseNumber: string;
  driverLicenseState: string;
  dob: string;
  state: string;
  lastOpenAt: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type IGetDriverAddress = {
  address: string;
};

export type IResubmittedDocumentsResponse = {
  _id: string;
  driver: string;
  newDrivingLicenseFile: string;
  newVehicleInsuranceFile: string;
  verificationStatus: string;
  createdAt: string;
  updatedAt: string;
};

export type IGetVehicleDetails = {
  types: { label: string; value: string }[];
  makes: { label: string; value: string }[];
  models: { label: string; value: string }[];
};

export type IVerifyDriverBackgroundResponse = {
  success: boolean;
  error: string;
  statusCode: number;
};

export type IGetAllComlaints = IPaginationType & {
  docs: IGetAllComplaintsDocs[] | any;
};

export type IGetAllComplaintsDocs = {
  createdAt: string;
  curbside_pickup_meta?: {};
  instore_pickup_meta?: {};
  package_pickup_meta?: {};
  description: string;
  userType: 'user' | 'driver';
  _id: string;
  title: string;
  serviceId: string;
  unreadCount: number;
};
export type IUserTypeResponse = IGetAllComplaintsDocs & {
  userType: 'user';
  reportingUser: {
    email: string;
    fullName: string;
    gender: string;
    phone: string;
    profileImage: string;
    _id: string;
  };
  updatedAt?: string;
};
export type IDriverTypeResponse = IGetAllComplaintsDocs & {
  userType: 'driver';
  reportingDriver: {
    email: string;
    fullName: string;
    gender: string;
    phone: string;
    profileImage: string;
    _id: string;
    vehicleNumber: string;
    vehicleType: string;
  };
  updatedAt?: string;
};

export type IGetAllComplaintsBody = {
  limit: number;
  page: number;
  userType: string;
  search: string;
};

export type IGetAllNotificationDocs = {
  title: string;
  body: string;
  image?: string;
  status: string;
  _id: string;
  userType: string;
  __v: number;
  targets: string[];
  createdAt: string;
  updatedAt: string;
};

export type IGetAllNotifications = IPaginationType & {
  docs: IGetAllNotificationDocs[];
};

export type ISendNotification = {
  success: boolean;
};

export type IEditReferral = {
  credits: string | number;
  pointsRequired?: number | string;
  discountValue?: number | string;
  discountType?: string;
  serviceType?: string[];
  expiryDate?: string;
  startDate: string;
  userType?: string;
  isOfferActive?: boolean;
  _id?: string;
};

export type IAddOfferResponse = {
  pointsRequired: number;
  message: string;
  discountType: string;
  discountValue: number;
  serviceType: string[];
  validFrom: string;
  validTo: string;
  isOfferActive: boolean;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
};

export type IEditPromoBody = {
  description: string;
  discountType: string;
  discountValue: number;
  expiryDate: null | string;
  maxUsers: number;
  promoCode: string;
  serviceType: string[];
  startDate: string;
  isNotifyUser: boolean;
  maxBudget?: number;
  id: string;
  isSingleUse: boolean;
};

export type IGetServiceById = {
  _id: string;
  pickupLocation: {
    type: 'Point';
    coordinates: [number, number];
  };
  driver: {
    _id: string;
    coords: {
      type: 'Point';
      coordinates: [number, number];
    };
    fullName: string;
    email: string;
    phone: string;
    vehicleNumber: string;
    vehicleType: string;
    vehicleMake: string;
    vehicleModel: string;
    vehicleMakeYear: string;
    profileImage: string;
    drivingLicenseFile: string;
    vehicleInsuranceFile: string;
    gender: string;
    fcm: string[];
    isOnline: boolean;
    isBlocked: boolean;
    isEmailVerified: boolean;
    verificationStatus: string;
    isProfileCompleted: boolean;
    isStripeConnected: boolean;
    publicKey: string | null;
    isBiometricEnabled: boolean;
    createdBy: string;
    ratingCount: number;
    rating: number;
    ongoingOrder: string | null;
    appversion: number;
    wallet: number;
    pendingForClearance: number;
    isEligibleForPayout: boolean;
    status: string;
    driverLicenseNumber: string;
    driverLicenseState: string;
    dob: string;
    state: string;
    lastOpenAt: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  promoCode: string | null;
  offer: string | null;
  user: {
    _id: string;
    email: string;
    phone: string;
    fullName: string;
    gender: string;
    state: string;
    fcm: string[];
    isBlocked: boolean;
    isEmailVerified: boolean;
    profileImage: string;
    publicKey: string;
    isBiometricEnabled: boolean;
    createdBy: string;
    ratingCount: number;
    rating: number;
    appversion: number;
    referredBy: string | null;
    customerId: string;
    status: string;
    lastOpenAt: string;
    selectedAccountType: string;
    businessName: string;
    businessWebsite: string;
    mainProductsOfDelivery: string[];
    username: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    businessAddress: {
      address: string;
      city: string;
      country: string;
      lat: number;
      lng: number;
      locationName: string;
      state: string;
    };
  };
  logs: Array<{
    actionFromLocation: {
      latitude: number;
      longitude: number;
    };
    status: string;
    actionBy: string;
    _id: string;
    createdAt: string;
    updatedAt: string;
  }>;
  declinedBy: string[];
  serviceCompletion?: {
    secureLocation: {
      place: string;
      image: string;
    };
    feedback: string;
    directDeliver: boolean;
    _id: string;
    createdAt: string;
    updatedAt: string;
  };
  serviceMeta: {
    preferredDeliveryMethod: {
      type: string;
    };
    pickupLocation: {
      firstName: string;
      lastName: string;
      phoneNumber: string;
      lat: number;
      lng: number;
      locationName: string;
      address: string;
      addressCtd: string;
      city: string;
      state: string;
      country: string;
      proofOfPurchase?: string;
    };
    deliveryLocation: {
      contactName: string;
      phone: string;
      lat: number;
      lng: number;
      locationName: string;
      address: string;
      city: string;
      state: string;
      country: string;
    };
    _id: string;
    deliveryInstruction: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
  serviceMetaType: 'package_pickup_meta' | string;
  userUnreadCount: number;
  driverUnreadCount: number;
  status: string;
  maxDistance: number;
  minDistance: number;
  discount: number;
  discountedUserTotal: number;
  driverTotal: number;
  paymentIntent: string;
  isDriverEarningPendingForClearance: boolean;
  isDirectDelivery: boolean;
  pin: number;
  tip: number;
  scheduleTime: string | null;
  driverRoute: Array<{
    latitude: number;
    longitude: number;
    _id: string;
  }>;
  createdAt: string;
  updatedAt: string;
  __v: number;
  batch?: any;
  isBatch?: boolean;
  distance: number;
  serviceCharges: number;
  userTotal: number;
  dropOffTime: string;
  swyveryTotal: string;
};

export type IGetLaunchedStates = IPaginationType & {
  docs: IGetLaunchedStateDocs[];
};

export type IGetLaunchedStateDocs = {
  _id: string;
  name: string;
  symbol: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type IAddStateResponse = {
  name: string;
  symbol: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type ICreateUserBody = {
  fullName: string;
  email: string;
  password: string;
  repeat_password: string;
  phone: string;
  profileImage: string;
  state: string;
};

export type IUserDetailsType = IGetAllUsers & {
  ratingCount: number;
  rating: number;
  createdBy: string;
  totalOrders: number;
  completedOrders: number;
};

export type IGetWithDraw = {
  success: boolean;
  totalCount: number;
  totalPages: number;
  transactions: {
    _id: string;
    driver: any | null;
    amount: number;
    type: string;
    withdrawalStatus: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  }[];
};

export type IPayOutResponse = {
  amount: string;
  driver: string | undefined;
  description: string;
};

export type ICounter = {
  count: number;
};

export type IUpload = {
  ETag: string;
  ServerSideEncryption: string;
  Location: string;
  key: string;
  Key: string;
  Bucket: string;
};

export type IGetLaunchedStatesbody = {
  limit?: number;
  page?: number;
  search?: string;
};

export type IAddPromoCodeResponse = {
  success: boolean;
  message: string;
  data: {
    promoCode: string;
    serviceType: string[];
    discountType: string;
    discountValue: number;
    description: string;
    maxBudget: number;
    remainingBudget: number;
    startDate: string;
    expiryDate: string | null;
    maxUsers: number;
    currentUsage: number;
    isNotifyUser: boolean;
    isPromoCodeActive: boolean;
    isSingleUse: boolean;
    _id: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
};

export type ISetComplaintReplyBody = {
  message: string;
  to: string;
  toUserType: string;
  complaint: string;
};

export type ISetComplaintReplyResponse = {
  success: boolean;
  data: {
    from: string;
    complaint: string;
    message: string;
    status: string;
    userType: string;
    _id: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
  };
};

export type IGetComplaintReplies = IPaginationType & {
  docs: IGetComplaintReplieDocs[];
};
export type IGetComplaintReplieDocs = {
  _id: string;
  from: string;
  complaint: string;
  message: string;
  status: string;
  userType: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type IGetComplaintById =
  | {
    from: string;
    complaint: string;
    message: string;
    status: string;
    userType: string;
    _id: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    reportingUser: {
      _id: string;
      email: string;
      fullName: string;
      gender: string;
      phone: string;
      profileImage: string;
    };
  }
  | any;
export type IModifyDriverBody = {
  verificationStatus: string;
  rejectReason?: string;
};

export type IGetAllFeedbackBody = {
  limit: number;
  userType: string;
  page: number;
};

export type IGetAllNotificationsBody = {
  userType: string;
  limit: number;
  page: number;
};

export type IGetAllPromoCodesBody = {
  page: number;
  startDate: string;
  expiryDate: string;
  serviceType: string;
  isActive: string;
};

export type IGetAllSubmissionRequestBody = {
  page: number;
};

export type ICreateUserResponse = {
  _id: string;
  username: string;
  email: string;
  phone: string;
  fullName: string;
  gender: string;
  state: string;
  fcm: string[];
  isBlocked: boolean;
  isEmailVerified: boolean;
  profileImage: string;
  publicKey: string | null;
  isBiometricEnabled: boolean;
  createdBy: string;
  ratingCount: number;
  rating: number;
  appversion: number;
  referredBy: string | null;
  customerId: string;
  status: string;
  lastOpenAt: string;
  selectedAccountType: string;
  mainProductsOfDelivery: string[];
  salt: string;
  hash: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type ISendNotificationModelBody = {
  title: string;
  body: string;
  userType: string;
  specificTargets: boolean;
  targets: string[];
  image?: string | undefined;
  states?: string[] | undefined;
};

export type IAddSubscriptionPlans = {
  planName: string;
  planType: string;
  deliveries: string;
  price?: string;
  durationDays?: string;
  description: string;
  colorCode?: string;
};

export type IEditSubscriptionPlans = IAddSubscriptionPlans;

export enum ISubscriptionPlanColors {
  GREY = '#777777',
  BLUE = '#00A3E0',
  DARK_GREEN = '#267D61',
  LIGHT_GREEN = '#34D58B',
  PURPLE = '#9E0999',
  DARK_PURPLE = '#53559A',
  GREEN = '#58B304',
  VIOLET = '#8267FF',
  RED = '#FF5A5A',
  PINK = '#FF81C8',
  YELLOW = '#E6C200',
  ORANGE = '#F97316',
}

export type IGetAllPlantypes = {
  docs: IGetAllPlantypesDocs[];
};

export type IGetAllPlantypesDocs = {
  _id: string;
  planType: string;
  createdAt: string;
  updatedAt: string;
};

export type IAddSubscriptionResponse = {
  _id: string;
  planName: string;
  description: string;
  price: number;
  deliveries: number;
  planType: string;
  active: boolean;
  colorCode: string;
  isDelete: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type IGetRemainingDeliveryStatus = {
  remainingDeliveriesStatus: boolean;
};

export type IBatch = {
  _id: string;
  batchNumber?: string;
  type: BATCH_TYPES;
  status: BATCH_STATUSES;
  driver?: IDocsDriver | null;
  totalOrders: number;
  totalPickUpStops: number;
  totalDropOffStops: number;
  totalDistance: number;
  openedAt: Date;
  dispatchAt?: Date | null;
  completedAt?: Date | null;
  closedAt?: Date | null;
  closedReason?: BATCH_CLOSED_REASONS | null;
  declinedBy?: string[];
  createdAt: Date;
  updatedAt: Date;
};

export type IGetAllBatches = IPaginationType & {
  docs: IGetAllBatchesDocs[];
};

export type IGetAllBatchesDocs = {
  _id: string;
  batchNumber: string;
  status: string;
  driver: IDocsDriver[];
  totalOrders: number;
  totalPickUpStops: number;
  totalDropOffStops: number;
  createdAt: string;
};

export type IGetAllBatchesBody = {
  page?: number;
  fromdate?: string;
  todate?: string;
  driver?: string;
  status?: string;
  limit?: number;
};

export type IGetBatchDetailsResponse = {
  batch: IBatch;
  orders: IGetServiceById[];
  pricing: {
    _id: string;
    totalUserAmount: number;
    totalDriverAmount: number;
    totalServiceCharges: number;
    totalDiscount: number;
    paymentStatus: string;
    tip: number;
  } | null;
  logs: {
    _id: string;
    batch: string;
    event: string;
    triggeredBy: string;
    createdAt: string;
    metadata: any;
  }[];
};

export type IBatchConfig = {
  MAX_PICKUP_STOPS: number;
  MAX_DELIVERY_STOPS: number;
  BATCH_WINDOW_MINUTES: number;
  MAX_PICKUP_RADIUS_MILES: number;
  MAX_TOTAL_ROUTE_MILES: number;
  MAX_SCHEDULE_WINDOW_MINUTES: number;
  SCHEDULED_DISPATCH_LEAD_MINUTES: number;
  UNASSIGNED_TIMEOUT_MINUTES: number;
  SAME_PICKUP_LOCATION_THRESHOLD_MILES: number;
};

